import { render, staticRenderFns } from "./RoApcnTable.vue?vue&type=template&id=4f193fe1&"
import script from "./RoApcnTable.vue?vue&type=script&lang=js&"
export * from "./RoApcnTable.vue?vue&type=script&lang=js&"
import style0 from "./RoApcnTable.vue?vue&type=style&index=0&id=4f193fe1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports